import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { PageTitles } from "../../../constants";

import ViewNotification from "./ViewNotification";

export default function ViewNotificationDetails() {
    return (
        <>
            <div className="page-content">
                <Helmet>
                    <title>{PageTitles.VIEW_NOTIFICATION}</title>
                </Helmet>
                <Container fluid className="customer-details">
                    <ViewNotification />
                </Container>
            </div>
        </>
    );
}
